import React from 'react'

import {MantineProvider} from '@mantine/core'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import {configureStore} from '@reduxjs/toolkit'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import 'primeicons/primeicons.css'
import {PrimeReactProvider} from 'primereact/api'
import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-cyan/theme.css'
import ReactDOM from 'react-dom/client'
import {Provider} from 'react-redux'
import {BrowserRouter} from 'react-router-dom'

import App from './App'
import {AlertManager} from './Components/Common/AlertManager/AlertManager'
import client from './infra/config/AxiosConfig'
import rootReducer from './slices'

const MyComponent = () => {
  const store = React.useMemo(
    () =>
      configureStore({
        reducer: rootReducer,
        devTools: true,
        middleware: getDefaultMiddleware =>
          getDefaultMiddleware({serializableCheck: false})
      }),
    []
  )

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        cacheTime: 0
      }
    }
  })

  client.setupInterceptors(store)

  return (
    <MantineProvider
      theme={{
        fontFamily: 'Campton, sans-serif'
      }}>
      <QueryClientProvider client={queryClient}>
        <PrimeReactProvider>
          <Provider store={store}>
            <BrowserRouter>
              <App />
              <AlertManager />
            </BrowserRouter>
          </Provider>
        </PrimeReactProvider>
      </QueryClientProvider>
    </MantineProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(<MyComponent />)
